import { useEffect, useState } from 'react';
// material
import { Stack, Button, Divider, Typography } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
// component
import Iconify from '../../components/Iconify';

import AuthService from '../../services/auth_service'

import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";

import { googleLogin } from '../../actions/auth';
// ----------------------------------------------------------------------

export default function AuthSocial() {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setLoading] = useState(false);

  const handleGoogleAuth = () => {
    AuthService.getGoogleAuth().then((response) => {
      let url = response.data['authorization_url'];
      window.location.replace(url);
    })
  }

  useEffect(() => {
    let params = new URLSearchParams(new URL(window.location.href).search);
    // let state = params.get('state', '');
    // let code = params.get('code', '');
    // let code_verifier = params.get('code_verifier', '');
    // let error = params.get('error', '');
    if (params !== undefined && params.get('state', '') !== '') {
      setLoading(true);
      dispatch(googleLogin(params))
        .then(() => {
          navigate("/apps");
        })
        .catch(() => {
          setLoading(false);
        });
    }
  }, []);


  // https://api.textalys.ai/auth/google/callback?state=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhdWQiOiJmYXN0YXBpLXVzZXJzOm9hdXRoLXN0YXRlIiwiZXhwIjoxNjc0ODAyOTY5fQ.1WbxylO08b_ahxGaKp6K8fFstLfpAzvu9O0kGydDDes&code=4%2F0AWtgzh44ENJ7y-IvcwQGhMmRjbNuYFaUQ6R2eLe74VB4TRh5DdOcHuPZqwkjqgSwGPbdLw&scope=email+profile+openid+https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuserinfo.email+https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuserinfo.profile&authuser=0&prompt=none

  return (
    <>
      <Stack direction="row" spacing={2}>
        <LoadingButton onClick={handleGoogleAuth} loading={isLoading} fullWidth size="large" color="inherit" variant="outlined">
          <Iconify icon="eva:google-fill" color="#DF3E30" width={22} height={22} />
        </LoadingButton>

        {/* <Button fullWidth size="large" color="inherit" variant="outlined">
          <Iconify icon="eva:facebook-fill" color="#1877F2" width={22} height={22} />
        </Button>

        <Button fullWidth size="large" color="inherit" variant="outlined">
          <Iconify icon="eva:twitter-fill" color="#1C9CEA" width={22} height={22} />
        </Button> */}
      </Stack>

      <Divider sx={{ my: 3 }}>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          OR
        </Typography>
      </Divider>
    </>
  );
}
